<template >
  <section class="twitter">
    <h1>twitter Component</h1>
  </section>
</template>

<script >
export default {
  name: "twitter",
  props: [],
  mounted() {},
  data() {
    return {};
  },
  methods: {},
  computed: {}
};
</script>

<style scoped lang="scss">
@import '../styles/_vars.scss';
.twitter {
  height: 100vh;
  width: 100vw;
  background-color: $color-white;
}
</style>
